import { type ReactElement } from 'react'
import { useTranslation } from 'react-i18next'
import { Spinner } from 'react-bootstrap'
import styles from '../assets/scss/ButtonLoadingSpinner.module.scss'

function ButtonLoadingSpinner (): ReactElement {
  const { t } = useTranslation()
  return (
    <Spinner
      className={styles.spinner}
      as="span"
      animation="border"
      size="sm"
      role="status"
    >
      <span className="visually-hidden">{t('message.loading')}</span>
    </Spinner>
  )
}

export default ButtonLoadingSpinner
